// extracted by mini-css-extract-plugin
module.exports = {"root":"Radio_root__3FHmk","label":"Radio_label__pr5wv","checkMark":"Radio_checkMark__-y2Jc","disabled":"Radio_disabled__2bcib"};